import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import Routes from './Routes';

// Suppress react-helmet-async UNSAFE_componentWillMount warning
const originalWarn = console.warn;
console.warn = (...args) => {
  if (args[0]?.includes?.('UNSAFE_componentWillMount') && args[0]?.includes?.('SideEffect')) {
    return; // Suppress this specific warning
  }
  originalWarn(...args);
};

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Routes />
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;